import { userDate } from 'owa-datetime';
import { TodoFolder, createTodoFolder } from 'owa-todo-types';
import TaskFolder from '../schema/TaskFolder';

export function toTodoFolder(serviceFolder: TaskFolder): TodoFolder {
    const todoFolder: TodoFolder = createTodoFolder({
        ...serviceFolder,
        OrderDateTime: serviceFolder.OrderDateTime ? userDate(serviceFolder.OrderDateTime) : null,
        FolderType: 'Other',
    });

    if (
        serviceFolder.FolderType &&
        serviceFolder.FolderType.toLowerCase() === 'com.microsoft.outlook.email.commitment'
    ) {
        todoFolder.FolderType = 'Commitments';
    }

    if (
        serviceFolder.FolderType &&
        serviceFolder.FolderType.toLowerCase() === 'com.microsoft.outlook.email.flagged'
    ) {
        todoFolder.FolderType = 'FlaggedEmails';
    }

    return todoFolder;
}
